<label
  class="mbs-switcher"
  [class.-disabled]="disabledState"
  [class.-readonly]="readonlyState"
  [class.-reverse]="labelPosition === 'left'"
  [class.fw-bold]="boldLabel"
  [class.w-100]="expandLabel"
  [ngClass]="labelClasses">
  <input
    #inputElement
    class="mbs-switcher_input"
    type="checkbox"
    [checked]="selected"
    [disabled]="disabledState"
    [id]="id"
    [name]="name"
    [readonly]="readonlyState"
    (change)="handleChange($any($event))"
    (click)="handleClick($any($event))" />

  <span class="mbs-switcher_track">
    <span class="mbs-switcher_toggler"></span>
  </span>

  @if (loading$ | async) {
    <span class="-loader loader-sm loader-primary my-1"></span>
  }

  @if (showStatus || label) {
    <span
      class="mbs-switcher_content"
      [class.-reverse]="statusPosition === 'right'"
      [class.overflow-hidden]="textOverflow"
      [class.w-100]="expandLabel && expandedLabelPosition === 'left'">
      @if (showStatus) {
        <mbs-status
          [class.justify-content-between]="statusPosition !== 'right'"
          [disabled]="disabledState"
          [iconPosition]="statusPosition !== 'right' ? 'right' : 'left'"
          [size]="MbsSize.md"
          [style.width]="statusWidth"
          [type]="selected ? statusType.success : statusType.danger">
          {{ selected ? Switch.on : Switch.off }}
        </mbs-status>
      }

      @if (label) {
        <span
          class="mbs-switcher_label"
          [class.-disabled]="disabledState"
          [class.text-overflow]="textOverflow">
          <span
            class="mbs-switcher_label-content"
            [ngClass]="labelSizeClass">
            @if (isTemplate(label)) {
              <ng-container
                [ngTemplateOutlet]="$any(label)"
                [ngTemplateOutletContext]="{ $implicit: labelContext }" />
            } @else {
              {{ label }}
            }
          </span>
        </span>
      }
    </span>
  }
</label>

<ng-content
  ngProjectAs="[appendLabel]"
  select="[appendLabel]" />

@if (subtitle && !subtitleHide) {
  <div
    class="mbs-switcher_subtitle"
    [class.-disabled]="disabledState"
    [class.-inside]="!subtitleOutside"
    [class.-reverse]="labelPosition === 'left'"
    [ngClass]="subtitleClasses">
    {{ subtitle }}
  </div>
}

@if (switcherDescription && !switcherDescription.hide) {
  <div
    class="mbs-switcher_description"
    [class.-inside]="!descriptionOutside"
    [class.-reverse]="labelPosition === 'left'"
    [ngClass]="descriptionClasses">
    <ng-template [ngTemplateOutlet]="switcherDescription.template" />
  </div>
}
